export type OS = 'mac' | 'win'

const detectOS = (): OS => (window.navigator.userAgent?.includes('Windows') ? 'win' : 'mac')

export default detectOS
